import { platformFeatures } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-12">
          <p className="text-sm text-foreground-500 font-medium tracking-wider uppercase mb-3">
            为什么选择我们
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight">
            最佳韩漫阅读体验
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {platformFeatures.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-100 rounded-2xl p-6 md:p-8 transition-transform duration-300 hover:scale-[1.02]"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-xl text-accent-500`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}